import { render, staticRenderFns } from "./Challenges.vue?vue&type=template&id=1f4da63e&scoped=true"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"
import style0 from "./Challenges.vue?vue&type=style&index=0&id=1f4da63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4da63e",
  null
  
)

export default component.exports